import { render, staticRenderFns } from "./ExpensesBulkCreation.vue?vue&type=template&id=a9b3161a&scoped=true"
import script from "./ExpensesBulkCreation.vue?vue&type=script&lang=js"
export * from "./ExpensesBulkCreation.vue?vue&type=script&lang=js"
import style0 from "./ExpensesBulkCreation.vue?vue&type=style&index=0&id=a9b3161a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b3161a",
  null
  
)

export default component.exports